export const hasAnyNonZeroProps = (value: object | number, seen = new WeakSet()): boolean => {
  if (!value) {
    return false;
  }

  const isArray = Array.isArray(value);
  const isObject = typeof value === 'object';
  const isNumber = typeof value === 'number';

  if (isNumber && !isNaN(value)) {
    return value !== 0;
  }

  if (isArray) {
    return value.some((v) => hasAnyNonZeroProps(v, seen));
  }

  if (isObject) {
    if (seen.has(value)) return false;
    seen.add(value);
    return Object.values(value).some((v) => hasAnyNonZeroProps(v, seen));
  }

  return false;
};
